import React, { memo, Suspense, useContext } from 'react';
import { ProgressIndicator } from '@fluentui/react/lib/ProgressIndicator';
import GridContainer from '../../connectedForm/GridContainer';
import { FilterOperation, IFilterInput, IProduct, ISalesOrderLine, Maybe } from '../../../graphql/schema/p4types';
import ConnectedFormContext from '../../Context/ConnectedFormContext';

const LazySalesOrderLineWorkspace = React.lazy(() => import('../../../views/sales/SalesOrderLineWorkspace'));

const QuoteItemOrderHistoryTabContent = memo(
  ({ quoteId, product }: { quoteId: Maybe<number>; product: Maybe<IProduct> }) => {
    const quoteHistoryFilters: Array<IFilterInput> = [
      {
        filterParameters: {
          field: 'salesOrder.originalOrderId',
          value: `${quoteId}`,
        },
        filterOperation: FilterOperation.Equals,
      },
      {
        filterParameters: {
          field: 'product.id',
          value: `${product?.id}`,
        },
        filterOperation: product?.id ? FilterOperation.Equals : FilterOperation.IsNotNull,
      },
    ];

    return (
      <Suspense fallback={<ProgressIndicator />}>
        <GridContainer>
          <LazySalesOrderLineWorkspace
            embeddedView={true}
            predefinedFilters={quoteHistoryFilters}
            viewScreenName="/sales/quote/itemOrderHistory"
          />
        </GridContainer>
      </Suspense>
    );
  }
);

export default ({ product }: { product: Maybe<IProduct> }) => {
  const connectedForm = useContext(ConnectedFormContext);

  return <QuoteItemOrderHistoryTabContent quoteId={(connectedForm.values as ISalesOrderLine)?.id} product={product} />;
};
